import { IAutomationObject } from '../../types'
import { OperationState } from "../OperationState";
import { IValveVar } from '../ValveVar';

export interface IVolumetricFlowController extends IValveVar {


}

export const schema = 'AutomationApps.Devices.Valves.VolumetricFlowController';